import React from 'react'
import {
  TitleContainer,
  IconTile,
  ListTile,
  ListTileItem,
} from '../../'

const Admin = (props) => {
  const {
    history,
    steps,
  } = props

  return (
    <TitleContainer title="Admin">
      <ListTile>
        {steps && Array.isArray(steps) && steps.map((step, index) => (
          <ListTileItem
            key={`element-${step.id}`}
            index={index}
            length={steps.length}
          >
            <IconTile
              handleClick={() => history.push(`/admin/${step.path}`)}
              node={step}
            />
          </ListTileItem>
        ))}
      </ListTile>
    </TitleContainer>
  )
}

export default Admin



// WEBPACK FOOTER //
// ./src/modules/admin/components/admin.jsx